"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaLeft;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UIMediaLeft(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('private-media__item', 'private-media__item--left', className)
  }));
}

UIMediaLeft.displayName = 'UIMediaLeft';
UIMediaLeft.propTypes = {
  children: _react.PropTypes.node
};
module.exports = exports.default;